import PropTypes from 'prop-types';
import ArticleActions from '../../articleActions/articleActions';
import ViewAtScopusAnchor from '../../articleActions/actionTypes/viewAtScopusAnchor';
import { NavigationClickEventDataPropTypes } from '../../../utils/trackers/adobe';

export default function EidReferencePreviewActions({ eid, viewAtScopusEventData }) {
  return (
    <ArticleActions>
      <ViewAtScopusAnchor
        id={`eid-reference-preview-${eid}`}
        eid={eid}
        viewAtScopusEventData={viewAtScopusEventData}
      />
    </ArticleActions>
  );
}

EidReferencePreviewActions.propTypes = {
  eid: PropTypes.string.isRequired,
  viewAtScopusEventData: PropTypes.shape(NavigationClickEventDataPropTypes).isRequired,
};
